import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, UntypedFormControl } from '@angular/forms';

@Pipe({
  name: 'controlRequired'
})
export class ControlRequiredPipe implements PipeTransform {

  private emptyFormControl = new UntypedFormControl();

  transform(value: AbstractControl, args?: any[]): boolean {
    // noinspection SuspiciousInstanceOfGuard
    return value && value instanceof AbstractControl && this.isRequired(value);
  }

  private isRequired(abstractControl: AbstractControl): boolean {
    if (abstractControl.validator) {
      const validator = abstractControl.validator(this.emptyFormControl);
      if (validator && validator.required) {
        return true;
      }
    }

    return false;
  }
}
